import './style.scss';

import walkIcon from '../../../../../../../../../assets/icons/walk-dark.svg';
import bikeIcon from '../../../../../../../../../assets/icons/bike-dark.svg';
import carIcon from '../../../../../../../../../assets/icons/car-dark.svg';
import { TransportMode } from '../../../../../../../../models/transport-mode.enum';
import DataUrlHelper from '../../../../../../../../helpers/data-url.helper';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { DistanceHelper } from '../../../../../../../../helpers/distance.helper';
import { DateHelper } from '../../../../../../../../helpers/date.helper';

function getTransportModeIconUrl(transportMode: TransportMode): string {
  if (transportMode === TransportMode.walk) {
    return DataUrlHelper.encode(walkIcon);
  }
  if (transportMode === TransportMode.bike) {
    return DataUrlHelper.encode(bikeIcon);
  }
  if (transportMode === TransportMode.car) {
    return DataUrlHelper.encode(carIcon);
  }
  return '';
}

function getActivityName(transportMode: TransportMode): string {
  if (transportMode === TransportMode.walk) {
    return TranslationService.get('common.activity.walk');
  }
  if (transportMode === TransportMode.bike) {
    return TranslationService.get('common.activity.bike');
  }
  if (transportMode === TransportMode.car) {
    return TranslationService.get('common.activity.drive');
  }
  return '';
}

function TravelTo({ transportMode, durationInMinutes, distanceInMeters }: { transportMode: TransportMode; durationInMinutes: number | undefined; distanceInMeters: number | undefined }) {
  return (
    <div className="bg-gray rounded p-3 travel-to d-flex align-items-center">
      <img className="travel-to__icon me-1" src={getTransportModeIconUrl(transportMode)} alt="" />
      <span>{getActivityName(transportMode)}&nbsp;</span>
      {transportMode === TransportMode.walk && distanceInMeters !== undefined && distanceInMeters > 0 && <span className="text-nowrap">{DistanceHelper.format(distanceInMeters)}&nbsp;</span>}
      {transportMode !== TransportMode.walk && durationInMinutes !== undefined && durationInMinutes > 0 && (
        <span className="text-nowrap">{DateHelper.formatAsHoursAndMinutes(durationInMinutes)}&nbsp;</span>
      )}
    </div>
  );
}

export default TravelTo;
